import { render } from "./TheNavbar.vue?vue&type=template&id=000920b5&ts=true"
import script from "./TheNavbar.vue?vue&type=script&lang=ts"
export * from "./TheNavbar.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__